// extracted by mini-css-extract-plugin
module.exports = {"table":"DataTable_table__3Z4Iw","padding-cell":"DataTable_padding-cell__10P_z","weekend":"DataTable_weekend__mBzwQ","highlight":"DataTable_highlight__1ae7S"};